/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

export default {
  methods: {
    generateMapperLink(program) {
      return {
        name: 'objectMapper',
        params: {
          leftType: 'Objective',
          objectIds: program.scopedObjectiveIds.join(','),
          rightType: 'Control',
          redirectUrl: this.$router.resolve({ name: 'programScoping' }).href,
          backUrl: this.$router.resolve({ name: 'programScoping' }).href,
        },
      };
    },
  },
};
